import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const PrimaryPathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black }, ref)=>jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        viewBox: "0 0 2364 1544",
        children: jsx("path", {
            ref: ref,
            d: "M130 1378.84c7.19-162.58 41.276-336.33 159.111-448.578 90.008-85.747 215.7-122.496 337.929-144.599 136.211-24.632 274.684-34.884 412.89-42.207 124.89-6.658 252.05-11.185 370.02-52.327 117.97-41.143 227.95-125.958 266.03-244.992 60.98-190.535-105.06-368.553-297.72-301.846-169.36 58.718-276.02 237.802-280.94 411.559-4.93 173.226 76.96 340.992 195.33 467.48 237 253.38 597.16 347.78 941.35 390.66",
            stroke: color,
            strokeWidth: 260,
            strokeMiterlimit: 10,
            fill: "none",
            strokeLinecap: "round"
        })
    }));

export { PrimaryPathwayIllustration as default };
